<template>
    <v-app>
        <v-navigation-drawer persistent v-model="drawerShowBySize" :width="drawerFullText ? 220 : 60" :temporary="!drawerFixedBySize" :stateless="drawerFixedBySize" hide-overlay disable-resize-watcher app v-show="signedIn">
            <!-- <v-navigation-drawer temporary floating clipped v-model="drawer" enable-resize-watcher app> -->
            <v-layout fill-height column>
                <v-flex xs11>
                    <v-list dense ref="navMenu">
                        <v-list-tile>
                            <v-toolbar app fixed dark dense flat class="primary darken-1" clipped-left>
                                <v-btn dark icon @click.stop="drawerShow = !drawerShow" class="v-toolbar__side-icon"><v-icon>arrow_back</v-icon></v-btn>
                                <span class="title ml-3 mr-5">Menu</span>
                            </v-toolbar>
                        </v-list-tile>
                        <template v-for="(item, i) in items">
                            <v-layout v-if="item.heading" :key="i" row align-center>
                                <v-flex xs12>
                                    <v-subheader v-if="item.heading && drawerFullText" class="text-uppercase">{{ item.heading }}</v-subheader>
                                </v-flex>
                                <!-- <v-flex xs6 class="text-xs-right">
                                    <v-btn small flat>edit</v-btn>
                                </v-flex> -->
                            </v-layout>
                            <v-divider v-else-if="item.divider" :key="i" dark></v-divider>
                            <v-list-tile v-else :key="i" :disabled="item.disabled" :class="item.disabled ? 'opa-3' : ''" @click="onMenuClick(item)">
                                <v-list-tile-action>
                                    <v-icon>{{ item.icon }}</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title class="grey--text text--darken-3">{{ item.text }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                    </v-list>
                </v-flex>
                <v-flex xs1>
                    <v-layout align-space-between justify-end column fill-height>
                        <div>
                            <v-layout>
                                <v-flex xs9 v-if="drawerFullText">
                                    <div class="text-xs-right lone-label mt-3 mr-2">Menu options</div>
                                </v-flex>
                                <v-flex xs3>
                                    <v-menu v-model="drawerMenu" :close-on-content-click="false" offset-x>
                                        <v-btn flat icon slot="activator"><v-icon>more_vert</v-icon></v-btn>
                                        <v-card>
                                            <v-list>
                                                <v-list-tile>
                                                    <v-list-tile-action>
                                                        <v-switch v-model="drawerFixed" color="primary"></v-switch>
                                                    </v-list-tile-action>
                                                    <v-list-tile-title>Menu always visible</v-list-tile-title>
                                                </v-list-tile>

                                                <v-list-tile>
                                                    <v-list-tile-action>
                                                        <v-switch v-model="drawerFullText" color="primary"></v-switch>
                                                    </v-list-tile-action>
                                                    <v-list-tile-title>Full menu with icons and text</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-card>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-navigation-drawer>
        <v-toolbar app fixed dark dense color="primary" clipped-left v-show="signedIn">
            <v-toolbar-side-icon v-if="!drawerFixedBySize" @click.stop="drawerShow = !drawerShow" class="mr-3"></v-toolbar-side-icon>
            <!-- <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon> -->
            <span class="title ml-3">{{ ViewCompany.Name }}<!-- &nbsp;<span class="font-weight-light">{{ Region }}</span> --></span>
            <span class="title ml-4 mr-4">{{ CurrentView }}</span>
            <v-spacer></v-spacer>
            <v-menu offset-y v-if="User.DN!=='MSSL Admin'">
                <v-btn slot="activator" flat icon>
                    <v-icon>add_circle</v-icon>
                </v-btn>
                <v-list>
                    <v-list-tile v-for="(item, index) in addMenuItems" :key="index" class="list-auto-h" @click="onAddMenu(item)">
                        <v-list-tile-sub-title>{{ item.value }}</v-list-tile-sub-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-btn flat icon class="mr-4" @click="onSessionQuote" v-if="User.DN!=='MSSL Admin'">
                <v-icon>assignment</v-icon>
            </v-btn>
            <v-text-field solo-inverted flat hide-details label="Search" prepend-inner-icon="search" class="toolbar-search-box" v-if="User.DN!=='MSSL Admin'"></v-text-field>
            <!-- <v-spacer></v-spacer> -->
            <!-- <v-btn icon @click.stop="rightDrawer = !rightDrawer">
                <v-icon>more_vert</v-icon>
            </v-btn> -->
        </v-toolbar>
        <v-content>
            <transition name="fade">
                <router-view/>
            </transition>
        </v-content>
        <v-navigation-drawer temporary :right="right" v-model="rightDrawer" fixed app>
            <v-list>
                <v-list-tile @click="right = !right">
                <v-list-tile-action>
                    <v-icon>compare_arrows</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Switch drawer (click me)</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <v-footer app class="pa-3" v-show="signedIn">
            <v-icon>account_circle</v-icon>
            <v-menu open-on-hover top offset-y>
                <div slot="activator">
                    <span class="font-weight-medium pl-1 pr-3">{{ User.DN }}</span>
                </div>
                <v-list>
                    <v-list-tile v-for="(item, index) in userMenuItems" :key="index" class="list-auto-h" @click="onUserMenu(item)">
                        <v-list-tile-sub-title>{{ item.value }}</v-list-tile-sub-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-icon>verified_user</v-icon>
            <span class="font-weight-medium pl-1 pr-3">{{ User.Role }}</span> <!-- User.Role -->
            <v-icon color="primary" v-if="SelectedCustomer.SN_NAME">business</v-icon>
            <span class="font-weight-medium pl-1 pr-3 primary--text" v-if="SelectedCustomer.SN_NAME">{{ SelectedCustomer.SN_NAME }}</span>
            <v-spacer></v-spacer>
            <span>&copy; {{ new Date().getFullYear() }} {{ ViewCompany.Name }}</span>
        </v-footer>
        <!-- Confirm Feedback -->
        <v-dialog v-model="confirm.show" max-width="500">
            <v-card>
                <v-card-title class="headline">{{ confirm.title }}</v-card-title>
                <v-card-text>
                    {{ confirm.text }}
                    <br/>
                    <b>{{ confirm.value }}</b>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="onConfirm(false)">Cancel</v-btn>
                    <v-btn color="primary" @click="onConfirm(true)">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Prompt Input -->
        <v-dialog v-model="prompt.show" max-width="600">
            <v-card>
                <v-card-title class="headline">{{ prompt.title }}</v-card-title>
                <v-card-text>
                    {{ prompt.text }}
                    <v-radio-group v-if="prompt.show && Array.isArray(prompt.options)" v-model="prompt.value">
                        <v-radio v-for="item in prompt.options" :key="item" :label="item" :value="item"></v-radio>
                    </v-radio-group>
                    <v-text-field v-if="prompt.show && !Array.isArray(prompt.options)" v-model="prompt.value" @keyup.native="onPromptKey" clearable autofocus></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="onPromptClick(false)">Cancel</v-btn>
                    <v-btn color="primary" @click="onPromptClick(true)">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Busy -->
        <v-dialog v-model="processing.show" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    {{ processing.text }}
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- Alert -->
        <v-snackbar
            v-model="snack.show"
            top
            :color="snack.color"
            :multi-line="false"
            :timeout="snack.timeout"
            :vertical="true">
            <div class="title">{{ snack.title }}</div>
            <div class="subheading" v-html="snack.text"></div>
            <div class="d-flex">
                <span class="opa-0 mt-6">{{ snack.timeoutCounter }}s</span>
                <v-spacer></v-spacer>
                <v-btn dark flat class="ma-2" @click="closeAlert()">
                    OK
                </v-btn>
            </div>
        </v-snackbar>
    </v-app>
</template>

<script>
import { differenceInHours, isDate, parseISO, subHours } from 'date-fns';
import router from './router';

export default {
    name: 'App',
    data() {
        return {
            snack: {
                show: false,
                color: 'primary',
                timeout: 6000,
                timeoutCounter: 6,
                title: 'Alert',
                text: 'Message',
            },
            confirm: {
                show: false,
                title: 'Confirm',
                text: 'Message',
                id: 0
            },
            prompt: {
                show: false,
                title: 'Input',
                text: 'Message',
                id: 0
            },
            processing: {
                show: false,
                text: 'Please stand by',
            },
            addMenuItems: [
                { key: 'newquote', value: 'New Quote' },
                { key: 'codcust', value: 'COD Customer' },
                { key: 'doc', value: 'Document' }
            ],
            userMenuItems: [
                { key: 'settings', value: 'Settings' },
                { key: 'signout', value: 'Sign Out' }
            ],
            CurrentView: 'Dashboard',
            SelectedCustomer: {},
            signedIn: false,
            User: { has: () => 0 },
            ViewCompany: {},
            /* User: {
                FullName: 'Marius Smit',
                Role: 'Administrator',
                Department: 'IT'
            }, */
            Region: 'Gauteng',
            drawerShow: false,
            drawerMenu: false,
            drawerFixed: false,
            drawerFullText: true,
            selectedPath: '/Dashboard',
            items: [],
            right: true,
            rightDrawer: false,
            isJmpUser: true // FIXME: Change this to check UT_Id (user type id)
        };
    },
    watch: {
        drawerFixed(val) {
            this.$ls.set('DrawerFixed', val);
        },
        drawerFullText(val) {
            this.$ls.set('DrawerFullText', val);
        }
    },
    computed: {
        drawerShowBySize: {
            get() {
                if (this.signedIn && this.drawerFixed && this.drawerShow === false) this.drawerShow = true;
                return this.drawerShow;
            },
            set(newValue) {
                this.drawerShow = newValue;
            }
        },
        drawerFixedBySize() {
            if (!this.signedIn) return false;
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                case 'sm': {
                    return false;
                }
                default: {
                    return this.drawerFixed;
                }
            }
        }
    },
    mounted() {
        // Listen for notifcation messages.
        this.$root.$on('JMP_Notification', options => this.globalAlert(options));
        // Listen for confirm messages.
        this.$root.$on('JMP_Confirm', options => this.globalConfirm(options));
        // Listen for prompt messages.
        this.$root.$on('JMP_Prompt', options => this.globalPrompt(options));
        // Listen for processing messages.
        this.$root.$on('JMP_Process', options => this.globalProcess(options));
        // Listen for customer change/selection.
        this.$root.$on('JMP_Customer', customer => this.onCustomer(customer));

        this.drawerFixed = this.$ls.get('DrawerFixed', false);
        this.drawerFullText = this.$ls.get('DrawerFullText', true);
        this.drawerShow = this.drawerFixed;

        if (this.tmr) clearInterval(this.tmr);

        // this.$ls.clear(); // NOTE: Only for testing purposes.
        let isAuth = this.$ls.get('SignedIn', false);
        isAuth = typeof isAuth === 'string' ? isAuth === 'true' : isAuth;
        if (isAuth) this.signedIn = isAuth;

        let lastDate = this.$ls.get('LastDt', subHours(new Date(), 3));
        if (typeof lastDate === 'string') lastDate = parseISO(lastDate);
        if (!isDate(lastDate)) lastDate = subHours(new Date(), 3);
        if (differenceInHours(new Date(), lastDate) > 2) {
            isAuth = false;
            this.signedIn = false;
            this.$ls.set('SignedIn', false);
        }

        // Listen for authentication/signed in changes.
        this.$root.$on('SignedIn', data => {
            if (data === true) {
                this.User = this.$ls.get('User', {});
                Object.defineProperty(this.User, 'has', { value: this.$has });
                this.ViewCompany = this.$ls.get('ViewCompany', {});
                if (this.User.DN === 'MSSL Admin') this.$router.push({ path: 'MSSL' });
                else this.selectedPath = '/Dashboard';
            }
            this.populateMenu();
            this.signedIn = data;
        });

        // This makes sure the correct menu item stays highlighted.
        router.beforeEach((to, from, next) => {
            if (!this.$refs.navMenu) return;
            const items = this.$refs.navMenu.$el.querySelectorAll('li');
            items.forEach(o => {
                if (o.className.indexOf('is-active') > -1) {
                    o.className = o.className.replace('is-active', '');
                }
                if (o.dataset.r === to.path) {
                    o.className += ' is-active';
                }
            });
            next();
        });

        if (isAuth) {
            this.User = this.$ls.get('User', null);
            if (!this.User) { // The auth flag is set but the user is missing. Re-signin.
                this.User = {};
                this.items = [];
                this.$ls.set('SignedIn', false); // Store authentication state.
                this.$ls.set('User', null);
                this.$ls.set('Token', null);
                this.$http.defaults.headers.common.Authorization = null;
                this.$root.$emit('SignedIn', false);
            }
            Object.defineProperty(this.User, 'has', { value: this.$has });
            this.$http.defaults.headers.common.Authorization = this.$ls.get('Token');
            this.ViewCompany = this.$ls.get('ViewCompany', {});
            if (this.User.DN === 'MSSL Admin') this.$router.push({ path: 'MSSL' });
            else this.$router.push({ path: 'Dashboard' });
            this.populateMenu();
        }
        else if (window.location.pathname !== '/') {
            this.$ls.set('SignedIn', false); // Store authentication state.
            this.$ls.set('User', null);
            this.$ls.set('Token', null);
            this.$http.defaults.headers.common.Authorization = null;
            this.$root.$emit('SignedIn', false);
            this.$router.push({ path: '/' });
        }
    },
    methods: {
        onMenuClick(data) {
            // this.popActiveIndex = '';
            if (data.path) {
                if (!this.drawerFixed) this.drawerShow = false;
                this.selectedPath = data.path;
                // if (data.path === '/SignOut') this.drawerShow = false;
                const currentName = this.$router.currentRoute.name;
                this.CurrentView = data.text;
                this.$router.push({ path: data.path });

                if (currentName === 'PriceList' && data.path === '/CRP') {
                    this.$root.$emit('PriceSwitch', 'CRP');
                }
                else if (currentName === 'CRP' && data.path === '/PriceList') {
                    this.$root.$emit('PriceSwitch', 'STD');
                }
            }
        },
        // A global alert system triggered by this.$alert().
        globalAlert(options) {
            if (options.time) this.snack.timeout = options.time * 1000;
            this.snack.timeoutCounter = this.snack.timeout / 1000;
            this.snack.title = options.title || 'Alert';
            this.snack.text = options.message || '';
            this.snack.color = options.type || 'info';
            this.snack.show = true;
            if (this.snack.timeoutCounter > 0) {
                this.tmr = setInterval(this.alertHider.bind(this), 1000);
                setTimeout(() => {
                    clearInterval(this.tmr);
                }, this.snack.timeout);
            }
        },
        alertHider() {
            this.snack.timeoutCounter -= 1;
            if (this.snack.timeoutCounter > 0) return;
            clearInterval(this.tmr);
        },
        closeAlert() {
            if (this.tmr) clearInterval(this.tmr);
            this.snack.show = false;
        },
        // A global confirm system triggered by this.$confirm().
        globalConfirm(options) {
            this.confirm.title = options.title || 'Confirm?';
            this.confirm.text = options.message || '';
            this.confirm.value = options.value || '';
            this.confirm.show = true;
        },
        onConfirm(result) {
            this.confirm.show = false;
            this.$root.$emit('JMP_Confirm_Result', result);
        },
        // A global confirm system triggered by this.$prompt().
        globalPrompt(options) {
            this.prompt.title = options.title || 'Enter value';
            this.prompt.text = options.message || '';
            this.prompt.value = options.value || '';
            this.prompt.options = options.options || null;
            this.prompt.show = true;
        },
        onPromptKey(evt) {
            if (evt.key === 'Enter') this.onPromptClick(true);
            else if (evt.key === 'Escape') this.onPromptClick(false);
        },
        onPromptClick(result) {
            this.prompt.show = false;
            this.$root.$emit('JMP_Prompt_Result', { Action: result, Value: this.prompt.value });
        },
        // A global confirm system triggered by this.$prompt().
        globalProcess(options) {
            this.processing.text = options.message || '';
            this.processing.show = options.show !== false;
        },
        // The context customer was changed/selected.
        onCustomer(customer) {
            this.SelectedCustomer = customer;
        },
        onAddMenu(item) {
            switch (item.key) {
                case 'newquote':
                    if (this.$router.currentRoute.name === 'Quote') {
                        this.$root.$emit('QuoteSwitch', 'New');
                        return;
                    }
                    this.selectedPath = '/Quote';
                    this.CurrentView = item.value;
                    this.$router.push({ path: this.selectedPath });
                    break;
                case 'codcust':
                    this.$alert({ title: 'To be implemented', message: 'To be implemented' });
                    break;
                case 'doc':
                    this.$alert({ title: 'To be implemented', message: 'To be implemented' });
                    break;
                default: break;
            }
        },
        onSessionQuote() {
            if (this.$router.currentRoute.name === 'Quote') {
                this.$root.$emit('QuoteSwitch', 'Session');
                return;
            }
            this.selectedPath = '/QuoteSession';
            this.CurrentView = 'Quote - Session';
            this.$router.push({ path: this.selectedPath });
        },
        onUserMenu(item) {
            switch (item.key) {
                case 'settings':
                    /* this.selectedPath = '/Settings';
                    this.CurrentView = item.value;
                    this.$router.push({ path: this.selectedPath }); */
                    this.$alert({ title: 'To be implemented', message: 'To be implemented' });
                    break;
                case 'signout':
                    this.$router.push({ name: 'SignOut' });
                    break;
                default: break;
            }
        },
        populateMenu() {
            this.isJmpUser = this.User.DN !== 'MSSL Admin';
            this.items = [];
            // this.items.push({ idx: idx++, label: 'Dashboard', icon: 'icon-screen', route: '/Dashboard', subs: [] }); // eslint-disable-line
            // if (this.user.has(this.viewCompany._id, [this.$CONST.PERMISSION.COMPANY_VIEW, this.$CONST.PERMISSION.COMPANY_EDIT])) this.items.push({ idx: idx++, label: 'Companies', icon: 'icon-apartment', route: '/Companies', subs: [] }); // eslint-disable-line
            if (this.isJmpUser) {
                this.items.push({ heading: 'Overview' });
                this.items.push({ icon: 'dashboard', text: 'Dashboard', path: '/Dashboard' });
                // { divider: true },
                // { heading: 'Workflow' },
                // this.items.push({ icon: 'account_circle', text: 'My Work', disabled: true });
                // this.items.push({ icon: 'supervised_user_circle', text: 'My Team\'s Work', disabled: true });
                this.items.push({ divider: true });
            }
            if (this.User.has(this.ViewCompany._id, [this.$CONST.PERMISSION.QUOTE_ACCESS, this.$CONST.PERMISSION.QUOTE_VIEW, this.$CONST.PERMISSION.QUOTE_EDIT])) {
                this.items.push({ heading: 'Quotes & Stock' });
                this.items.push({ icon: 'blur_linear', text: 'Quotes', path: '/QuoteList' });
                // this.items.push({ icon: 'filter_none', text: 'Stock Listing', disabled: true });
                // this.items.push({ icon: 'rotate_90_degrees_ccw', text: 'Request Stock', disabled: true });
                this.items.push({ divider: true });
            }
            if (this.User.has(this.ViewCompany._id, [this.$CONST.PERMISSION.PRICELIST_ACCESS, this.$CONST.PERMISSION.PRICELIST_VIEW, this.$CONST.PERMISSION.PRICELIST_EDIT])) {
                this.items.push({ heading: 'Price Lists' });
                this.items.push({ icon: 'grain', text: 'Standard Price List', path: '/PriceList' });
                this.items.push({ icon: 'collections_bookmark', text: 'C.R.P.', path: '/CRP' });
                this.items.push({ icon: 'bubble_chart', text: 'Interactive', path: '/Interactive' });
                // this.items.push({ icon: 'clear_all', text: 'Strip Calculator', path: '/StripCalculator' });
                this.items.push({ icon: 'clear_all', text: 'stripcalc', path: '/stripcalc' });
                // this.items.push({ icon: 'flip', text: 'Costing Program', disabled: true });
                // TODO: Technical Data Sheets.
                this.items.push({ divider: true });
            }
            const canCustomer = this.User.has(this.ViewCompany._id, [this.$CONST.PERMISSION.CUSTOMER_ACCESS, this.$CONST.PERMISSION.CUSTOMER_VIEW, this.$CONST.PERMISSION.CUSTOMER_EDIT]);
            const canDocuments = this.User.has(this.ViewCompany._id, [this.$CONST.PERMISSION.DOCUMENT_ACCESS, this.$CONST.PERMISSION.DOCUMENT_VIEW, this.$CONST.PERMISSION.DOCUMENT_EDIT]);
            const canRoles = this.User.has(this.ViewCompany._id, [this.$CONST.PERMISSION.ROLE_ACCESS, this.$CONST.PERMISSION.ROLE_VIEW, this.$CONST.PERMISSION.ROLE_EDIT]);
            const canDepartments = this.User.has(this.ViewCompany._id, [this.$CONST.PERMISSION.DEPARTMENT_ACCESS, this.$CONST.PERMISSION.DEPARTMENT_VIEW, this.$CONST.PERMISSION.DEPARTMENT_EDIT]);
            const canStaff = this.User.has(this.ViewCompany._id, [this.$CONST.PERMISSION.STAFF_ACCESS, this.$CONST.PERMISSION.STAFF_VIEW, this.$CONST.PERMISSION.STAFF_EDIT, this.$CONST.PERMISSION.STAFF_PROJECTS, this.$CONST.PERMISSION.STAFF_ROLES, this.$CONST.PERMISSION.STAFF_PASSWORD]);
            if (canCustomer || canDocuments || canRoles || canDepartments || canStaff) {
                this.items.push({ heading: 'Other' });
                if (canCustomer) this.items.push({ icon: 'business', text: 'Customers', path: '/Customers' });
                if (canCustomer) this.items.push({ icon: 'face', text: 'Customers COD', path: '/CustomersCOD' });
                if (canDocuments) this.items.push({ icon: 'folder_open', text: 'Documents', path: '/Document' });
                // this.items.push({ icon: 'event_note', text: 'Leave', disabled: true });
                // this.items.push({ icon: 'feedback', text: 'Feedback', disabled: true });
                // this.items.push({ icon: 'event_seat', text: 'Formal Inquiry', disabled: true });
                if (canRoles) this.items.push({ icon: 'fingerprint', text: 'Roles', path: '/Roles' });
                if (canDepartments) this.items.push({ icon: 'assignment_ind', text: 'Departments', path: '/Departments' });
                if (canStaff) this.items.push({ icon: 'people', text: 'Staff', path: '/Staff' });
                // this.items.push({ icon: 'trending_up', text: 'Reports', disabled: true });
                // this.items.push({ icon: 'settings', text: 'Administration', disabled: true });
            }

            // Supplier pages.
            const canMSSL = this.User.has(this.ViewCompany._id, [this.$CONST.PERMISSION.SUPPLIER_MSSL]);
            if (canMSSL) {
                this.items.push({ divider: true });
                this.items.push({ heading: 'Supplier' });
                this.items.push({ icon: 'view_comfy', text: 'MSSL Portal', path: '/MSSL' }); // local_shipping
                // this.items.push({ icon: 'public', text: 'MSSL Portal 2', path: '/MSSL2' });
                // this.items.push({ icon: 'file_copy', text: 'MSSL Data', path: '/MSSLData' });
            }
        }
    }
};
</script>

<style>
.toolbar-search-box .v-input__control {
    min-height: 35px !important;
}
.v-snack__content {
    height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue